import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={20} height={26} viewBox="0 0 20 26" fill="none" {...props}>
      <Path
        d="M10 5.25v-5L3.75 6.5 10 12.75v-5c4.137 0 7.5 3.363 7.5 7.5 0 4.137-3.363 7.5-7.5 7.5a7.506 7.506 0 01-7.5-7.5H0c0 5.525 4.475 10 10 10s10-4.475 10-10-4.475-10-10-10z"
        fill="#000"
      />
    </Svg>
  );
}

export default SvgComponent;
